// Textos da landing: src/content/{pt,en}.json (vindos do pacote de redesign aprovado).
// en.json tem a mesma forma de pt.json.
import pt from '../content/pt.json';
import en from '../content/en.json';

export type Language = 'pt-BR' | 'en';
export type Copy = typeof pt;

export const translations: Record<Language, Copy> = {
  'pt-BR': pt,
  en,
};
